import React, { useState } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { addTodo } from "../../redux/modules/TodosSlice";

function Form() {
     const initialState = {
          id: 0,
          title: "",
          body: "",
          isDone: false,
     }; //초기값

     const [todo, setTodo] = useState(initialState);
     //초기값설정
     const onChangeHandler = (e) => {
          const { name, value } = e.target;
          setTodo({ ...todo, [name]: value });
     };

     const dispatch = useDispatch();

     const onSubmitHandler = (e) => {
          e.preventDefault();
          if (todo.title === "" || todo.body === "") return;
          dispatch(addTodo({ ...todo }));
          // console.log(todo);
          setTodo(initialState);
     };

     return (
          <InputForm onSubmit={onSubmitHandler}>
               <InputMain>
                    <label>
                         제목{" "}
                         <input
                              type="text"
                              name="title"
                              value={todo.title} //버튼을 눌렀을 때  value값이 없어지게 하기 위해
                              onChange={onChangeHandler} //
                         ></input>
                    </label>
                    <label>
                         내용{" "}
                         <input
                              type="text"
                              name="body"
                              value={todo.body}
                              onChange={onChangeHandler}
                         ></input>
                    </label>
               </InputMain>
               <button>추가하기</button>
          </InputForm>
     );
}

export default Form;

const InputForm = styled.form`
     width: 100%;
     height: 100px;
     display: flex;
     justify-content: space-between;
     align-items: center;
     padding: 10px 20px;
     background-color: lightgray;
     border-radius: 10px;
     font-weight: 700;
     button {
          width: 15%;
          height: 46px;
          font-size: 20px;
          color: #fff;
          border-radius: 10px;
          border: transparent;
          background-color: steelblue;
          cursor: pointer;
     }
`;

const InputMain = styled.div`
     width: 70%;
     display: flex;
     justify-content: space-between;
     align-items: center;
     font-size: 20px;
     padding: 20px 25px;
     label {
          width: 48%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          input {
               width: 85%;
               height: 46px;
               border-radius: 10px;
               border: transparent;
               padding: 10px;
               font-size: 15px;
          }
     }
`;
